import React, { useEffect, useState, useRef } from 'react';
import { LOGOUT } from 'ConstComponents';
import { useHistory } from 'react-router-dom';
import { AddAPIAgent, AgentKYCStatus as AgentKYCStatus } from 'Components/Api/EzyPayAEPSAPI';
import { Container, Grid, Paper } from '@material-ui/core';
import { Formik, Form } from 'formik';
import HOCLoader from 'Components/Loader/HOCLoader';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import Box from '@material-ui/core/Box';
import RechargeIcon from 'Components/SvgButtons/RechargeIcon';
import ReactTable from 'Components/ReactTable/ReactTable';
import { MaterialDOBPickerField } from 'Components/Inputes/MaterialDOBPickerField';
import { SelectProfile as USER_SELECT_BY_ID } from 'Components/Api/UsersApi';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import ResetIcon from 'Components/SvgButtons/ResetIcon';
import usePosition from 'Components/Posistion';

const CustomContainer = HOCLoader(Container);
export const EzyPayOnboarding = () => {
    const classes = commonStyle();
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [status, setStatus] = useState('PROCESS');
    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [Message, setMessage] = useState('');
    const Mobile = localStorage.getItem('MobileNumber');
    const aadharNumber = localStorage.getItem('AadharNo');
    const history = useHistory();
    const formRef = useRef();
    const { latitude, longitude } = usePosition();
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [formObj, setFormObj] = useState({
        adhaarnumber: aadharNumber,
        MobileNumber: Mobile,
        Latitude: latitude,
        Longitude: longitude,
        DateOFBirth: '',
        DateOFBirth: null,

    });
    const reset = () => {
        setFormObj({
            adhaarnumber: '',
            MobileNumber: '',

        });
    };

    const SubmitHandle = async (values) => {
        setLoading(true);
        var requestObj = {
            ContactPerson: values.PersonName,
            MobileNumber: values.MobileNumber,
            Latitude: latitude,
            Longitude: longitude,
            DateOFBirth: values.DateOFBirth,

        };

        var request = JSON.stringify(requestObj);
        const response = await AddAPIAgent(request);
        setLoading(false);
        var data = JSON.parse(response.data);
        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(data.Message);

            setStatus('FAILURE');
            setMessage(data.Message);
            setIsAlertErrorOpen(true);
            return;
        }
        var data = JSON.parse(response.data);
        if ((data.Message === 'API Agent Added Successfully') || (data.Message === 'API Agent Already Exist')) {

            setResponseMessage(data.Message);

            history.push('/APIAgentKYC');
        }

        setMessage(data.Message);
    };

    useEffect(() => {
        setLoading(true);
        SelectByID();
    }, [latitude]);

    const SelectByID = async () => {
        setLoading(true);

        const { isAuthorized, status, data } = await USER_SELECT_BY_ID();
        setLoading(false);

        if (!isAuthorized) LOGOUT();

        if (!status) return;

        var d = JSON.parse(data);

        setFormObj({
            ...formObj,
            PanNo: d.PANNo,
            AadhaarNo: d.AadharNo,
            MobileNo: d.MobileNumber,
            City: d.City,
            Address: d.Address,
            PinCode: d.PinCode,
            DateOFBirth: '',
            DateOFBirth: null,
        });
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObj}
                onSubmit={SubmitHandle}
                resetForm={formObj}
            >
                {({ setFieldValue, values }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            yarn
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={1}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Aadhar No"
                                                        name="adhaarnumber"
                                                        placeholder="Aadhar No"
                                                        title="Aadhar No"
                                                        length="12"
                                                        typed_length={1}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Mobile Number"
                                                        name="MobileNumber"
                                                        icon="mobile"
                                                        placeholder="Mobile Number"
                                                        title="Mobile Number"
                                                        length="10"
                                                        typed_length={1}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialDOBPickerField
                                                        name="DateOFBirth"
                                                        label="Date Of Birth"
                                                        maxDate={new Date()}
                                                        value={values.DateOFBirth}
                                                        onChange={(value) =>
                                                            setFieldValue(
                                                                'DateOFBirth',
                                                                value
                                                            )
                                                        }
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                        <Grid className={classes.footerGrid}>
                                            <Box
                                                className={classes.flexReverse}
                                            >
                                                <div
                                                    className={
                                                        classes.SubmitWrapper
                                                    }
                                                >
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-md-5">
                                                                <SecondaryButton
                                                                    disabled={
                                                                        loading
                                                                    }
                                                                    endIcon={
                                                                        <ResetIcon />
                                                                    }
                                                                    title="Reset"
                                                                    onClick={() => {
                                                                        reset();
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="col-md-7">
                                                                <PrimaryButton
                                                                    title="Proceed"
                                                                    disabled={
                                                                        loading
                                                                    }
                                                                    endIcon={
                                                                        <RechargeIcon />
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </Grid>
                            {/* <Grid
                                item
                                xs={12}
                                sm={12}
                                md={8}
                                lg={8}
                                className="last Authentication"
                            >
                                <ReactTable
                                    data={transactions}
                                    columns={mainColumns}
                                    headerToolbar={false}
                                    footerToolbar={false}
                                />
                            </Grid> */}
                        </Grid>
                    );
                }}
            </Formik>

            {isAlertErrorOpen ? (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
